/* oxlint-disable react/forbid-elements */
import { createIcon, type ISVGIconProps, type ISVGProps } from '@cian/ui-kit-design-tokens/internal';
import * as React from 'react';

const IconComponent = React.forwardRef((props: ISVGProps, ref: React.Ref<SVGSVGElement>) => {
  return (
    <svg {...props} ref={ref} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M23 1H1V19H23V1Z" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="square" />
      <path
        fill="currentColor"
        d="M6 6H18"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        fill="currentColor"
        d="M6 10H18"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path stroke="currentColor" d="M6 14H11" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="square" />
    </svg>
  );
});

IconComponent.displayName = 'IconMyDeals24';

export const IconMyDeals24: React.FC<ISVGIconProps> = createIcon(IconComponent);
